import {ADD_ITEM, REMOVE_ITEM,
        SAVE_PAYMENT_METHOD,
        SAVE_SHIPPING_ADDRESS} from './cartConstants';

export const addItem = (newItem) => async (dispatch, getState) =>{
    console.log(newItem)
    dispatch({type : ADD_ITEM, payload : {newItem}})
    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
}

export const removeItem = (removedItem) => async (dispatch, getState) =>{
    dispatch({type : REMOVE_ITEM, payload : {removedItem}})
    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
}

export const saveShippingAddress = (address) => async (dispatch) =>{

    dispatch({type : SAVE_SHIPPING_ADDRESS, payload : address})

    localStorage.setItem('shippingAddress', JSON.stringify(address))
}

export const savePaymentMethod = (paymentMethod) => async (dispatch) =>{

    dispatch({type : SAVE_PAYMENT_METHOD, payload : paymentMethod})

    localStorage.setItem('paymentMethod', JSON.stringify(paymentMethod))
}